import React, {Component} from 'react';
import config from 'config';
import './index.scss';
import Modal from "components/Modal";

interface ScheduleCallModalProps {
  open: boolean;
  onClosing: ()=>void;
}

export default class ScheduleCallModal extends Component<ScheduleCallModalProps, {}> {
  render() {
    return <Modal open={this.props.open} onClosing={this.props.onClosing}
                  className="schedule-call-modal">
      <iframe src={config.contact.scheduleCallURL + "?embed=true"} title="Schedule call" />
    </Modal>;
  }
}